import {Component, input} from '@angular/core'
import {Observable, of} from 'rxjs'
import {IImage, TImageId} from '../../../application/types'

@Component({
  selector: 'spb-chart-base',
  template: ``
})
export class ChartBaseComponent {
  // Technically optional but you should probably set it.
  public imageId = input<TImageId>('regionalExposureOriginal')
  public savingsGoalId = input<string>('')

  /**
   * The print is not really async, but we make this async
   * so that we can handle it consistently in the app.
   *
   * Draw is called by the print from the _sub class_
   */
  public draw(): Observable<IImage> {
    return of({
      id: this.imageId(),
      savingsGoalId: this.savingsGoalId(),
      image: this.print()
    })
  }

  /**
   * We need this on the base class to be able to call it
   * consistently
   */
  protected print(): string {
    return 'not implemented'
  }
}
